import {
  Injectable
} from '@angular/core';
import {
  DataService
} from '../data.service';
import {
  IAboutUsViewModel,
  IFocusOverViewModel,
  IProcessesViewModel,
  ISpecialFilesViewModel,
  IFocusOverViewModelEdit,
  IcompanyCertificateViewModel
} from '../../models/supplierProfileModel';
import {
  Observable
} from 'rxjs/Observable';
import {
  ICustomProcessViewModel,
  ITempNPSDataModel
} from '../../models/rfqModel';
import {
  IMaterialViewModel
} from '../../models/globalMaster';
import {
  ICompanyModel
} from '../../models/accountModel';
import { IFollowContactViewModel } from '../../models/settingsModel';

@Injectable()
export class SupplierService {

  moduleUrl: string;
  data: any = {
    rfqId: 0
  };

  set(data: any, key: string) {
    this.data[key] = data;
  }

  get(key: string) {
    return this.data[key];
  }

  constructor(private _dataService: DataService) {}

  getAboutUsDetails(compId: number, contId: number, isBuyer: boolean,LoggedInId:number=0): Observable < any > {
    // this.moduleUrl = 'Supplier/GetAboutUs?CompanyId=' + compId + '&IsBuyer=' + isBuyer + '&ContactId=' + contId;
    // return this._dataService.getSingle(this.moduleUrl, '');
    this.moduleUrl = 'Supplier/GetAboutUs?CompanyId=' + compId +
    '&IsBuyer=' + isBuyer + '&ContactId=' + contId + '&LoggedInId=' + LoggedInId;
    return this._dataService.getSingle(this.moduleUrl, '');
  }
  getCapabilities(companyId: number): Observable < ICustomProcessViewModel[] > {
    this.moduleUrl = 'Supplier/GetSuppliersProcesses?CompanyId=' + companyId;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  getSuppliersSubscriptionProcesses(companyId: number): Observable < any > {
    this.moduleUrl = 'Supplier/GetSuppliersSubscriptionProcesses?companyId=' + companyId;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  getParentMaterialofCompany(companyId: number): Observable < IMaterialViewModel[] > {
    this.moduleUrl = 'Master/GetMaterialsData?CompanyId=' + companyId;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  getFocusOverview(companyId: number): Observable < IFocusOverViewModel > {
    this.moduleUrl = 'Supplier/GetFocusOver?CompanyId=' + companyId;
    return this._dataService.getAll(this.moduleUrl, '');
  }

  addSupplierEquipment(iAboutUsViewModel: IAboutUsViewModel): Observable < IAboutUsViewModel > {
    this.moduleUrl = 'Supplier/UpdateCompanyEquipments';
    return this._dataService.add(this.moduleUrl, iAboutUsViewModel);
  }
  UpdateFocusOverview(iProcessesViewModel: IFocusOverViewModelEdit): Observable < IFocusOverViewModelEdit > {
    this.moduleUrl = 'Supplier/UpdateFocusOverview';
    return this._dataService.add(this.moduleUrl, iProcessesViewModel);
  }

  updateSupplierCapability(iProcessesViewModel: IProcessesViewModel): Observable < IProcessesViewModel > {
    this.moduleUrl = 'Supplier/UpdateCapabilities';
    return this._dataService.UpdateWithoutId(this.moduleUrl, iProcessesViewModel);
  }

  addSpecialFile(iSpecialFilesViewModel: ISpecialFilesViewModel): Observable < any > {
    this.moduleUrl = 'Supplier/SetPhotos';
    return this._dataService.add(this.moduleUrl, iSpecialFilesViewModel);
  }

  editCompanyDescription(iCompanyViewModel: ICompanyModel): Observable < ICompanyModel > {
    this.moduleUrl = 'Supplier/EditCompanyDescription';
    return this._dataService.add(this.moduleUrl, iCompanyViewModel);
  }

  insertCertificates(icompanyCertificateViewModel: IcompanyCertificateViewModel[]): Observable < IcompanyCertificateViewModel > {
    this.moduleUrl = 'Supplier/InsertCompanyCertificates';
    return this._dataService.add(this.moduleUrl, icompanyCertificateViewModel);
  }

  updateCompanyDemographics(iAboutUsViewModel: IAboutUsViewModel): Observable < IAboutUsViewModel > {
    this.moduleUrl = 'Supplier/UpdateCompanyDemographics';
    return this._dataService.add(this.moduleUrl, iAboutUsViewModel);
  }

  getNPSRatings(contactId: number): Observable < ITempNPSDataModel > {
    this.moduleUrl = 'Rating/GetNPSDetail?ContactId=' + contactId;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  updateStripeCapabilities(iProcessesViewModel: IProcessesViewModel): Observable < any > {
    this.moduleUrl = 'Supplier/UpdateStripeCapabilities';
    return this._dataService.UpdateWithoutId(this.moduleUrl, iProcessesViewModel);
  }
  setFollowBlacklistContact(iFollowContactViewModel: IFollowContactViewModel): Observable < IFollowContactViewModel > {
    this.moduleUrl = 'Contact/SetFollowBlackListContact';
    return this._dataService.add(this.moduleUrl, iFollowContactViewModel);
  }

  getAvailableTokenEntitlements(companyId: number, mode: string = 'RFQ'): Observable<any> {
    this.moduleUrl = 'Vision/TokenEntitlements/Summary?companyId=' + companyId + '&mode=' + mode;
    return this._dataService.getAll(this.moduleUrl, '');
  }

  grantTokenEntitlements(companyId: number, tokenCount: number, mode: string = 'RFQ'): Observable<any> {
    this.moduleUrl = 'Vision/TokenEntitlements/Grant';
    return this._dataService.add(this.moduleUrl, {
      companyId: companyId,
      tokenCount: tokenCount,
      mode: mode
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/supplier/supplier.service.ts